<script>
import { Link, navigate } from "svelte-routing";
let nav
let src = 'logo.svg'
let openMenu = () => {
  nav.classList.toggle('hidden')
}

</script>

<!-- Create Navbar Menu -->
<header class="grid grid-cols-1 bg-purple-600">
  <nav class="bg-white shadow-md grid grid-cols-3 py-3 justify-between align-middle">
    <div class="grid col-sapn-1 text-xl font-bold p-1 pl-2">
      <img {src} alt="large pool mining" class="w-16 h-8 object-fit" />
    </div>
    <ul class="sm:grid hidden sm:col-span-2 sm:grid-cols-4 p-1 justify-self-end">
      <li class="mx-2"><a href="https://large-pool-mining.vercel.app/">Home</a></li>
      <li class="mx-2"><a href="https://wa.me/+12145665707">Contact</a></li>
      <li class="mx-2"><Link to="/">Logout</Link></li>
    </ul>
    <div on:click|preventDefault={openMenu} class="grid col-start-3 col-span-1 sm:hidden mt-2 p-1 justify-self-end font-xl font-bold text-lg">
      <i class="fas fa-bars" />
    </div>
  </nav>
  <ul class="shadow-md sm:hidden py-2 font-bold" bind:this={nav}>
    <li><a href="https://large-pool-mining.vercel.app/" class="block p-2 py-4 text-gray-100">Home</a></li>
    <li><a href="https://wa.me/+12145665707" class="block p-2 py-4 text-gray-100">Contact</a></li> 
    <li><Link to="/withdraw" class="block p-2 py-4 text-gray-100">Bank Withdrawal</Link></li>
    <li><Link to="/crypto" class="block p-2 py-4 text-gray-100">Crypto Withdraw</Link></li>
    <li><Link href="https://large-pool-mining.vercel.app/pricing.html" class="block p-2 py-4 text-gray-100">Pricing</Link></li>
    <li><Link to="/" class="block p-2 py-4 text-gray-100">Logout</Link></li>
  </ul>
</header>
